import moment from "moment";

const FormatDate = (value) => {
	return moment(value).format("DD MMM YYYY");
};

export default FormatDate;
